/**
 * AI驾驶舱版本状态管理
 */
const state = {
    // 当前版本配置（true=新版, false=老版）
    useNewVersion: true,
    // AI处理状态
    isAiProcessing: false,
};

const getters = {
    useNewVersion: state => state.useNewVersion,
    isAiProcessing: state => state.isAiProcessing,
};

const mutations = {
    /**
     * 设置版本配置
     */
    SET_VERSION(state, value) {
        state.useNewVersion = value;
    },
    
    /**
     * 切换版本
     */
    TOGGLE_VERSION(state) {
        state.useNewVersion = !state.useNewVersion;
    },

    /**
     * 设置AI处理状态
     */
    SET_AI_PROCESSING(state, value) {
        state.isAiProcessing = value;
    },
};

const actions = {
    /**
     * 初始化版本配置（从缓存读取）
     */
    initVersion({ commit }) {
        const cached = localStorage.getItem('aicockpit_useNewVersion');
        if (cached !== null) {
            commit('SET_VERSION', cached === 'true');
        } else {
            // 默认使用新版
            commit('SET_VERSION', true);
        }
    },
    
    /**
     * 设置版本配置并保存到缓存
     */
    setVersion({ commit }, value) {
        commit('SET_VERSION', value);
        localStorage.setItem('aicockpit_useNewVersion', String(value));
    },
    
    /**
     * 切换版本
     */
    toggleVersion({ commit, state }) {
        const newValue = !state.useNewVersion;
        commit('SET_VERSION', newValue);
        localStorage.setItem('aicockpit_useNewVersion', String(newValue));
        return newValue;
    },

    /**
     * 设置AI处理状态
     */
    setAiProcessing({ commit }, value) {
        commit('SET_AI_PROCESSING', value);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};